import Axios, { AxiosResponse } from "axios";

import { TAccountData } from "@profile/pages/AccountPage/IAccountPage";
import IProfileData from "@profile/pages/AccountPage/IProfileData";

class ProfileServiceClass {
  public changePassword(accountData: TAccountData): Promise<AxiosResponse> {
    return Axios.patch("/api/account/password", {
      _2fa_token: accountData.data.otp_code,
      new_password: accountData.data.new_password,
      password_confirmation: accountData.data.password_confirmation,
      old_password: accountData.data.old_password,
      log_out_of_other_devices: accountData.data.log_out_of_other_devices,
    });
  }

  public closeAccount(accountData: TAccountData): Promise<AxiosResponse> {
    const data = {
      _2fa_token: accountData.data.otp_code,
      password: accountData.data.old_password,
    };

    return Axios.patch("/api/account/close", data);
  }

  public changeEmail(accountData: TAccountData): Promise<AxiosResponse> {
    return Axios.patch("/api/account/emails", {
      email: accountData.data.email,
      _2fa_token: accountData.data.otp_code,
      current_password: accountData.data.old_password,
    });
  }

  public updateProfileData(profileData: IProfileData): Promise<AxiosResponse> {
    const { verification, profile, ...restData } = profileData;

    return Axios.patch("/api/account", {
      ...restData,
      account_data: profile,
    });
  }

  public resendConfirmationEmailChangeEmail(
    email: string
  ): Promise<AxiosResponse> {
    return Axios.post("/api/users/confirmation", {
      email,
    });
  }

  public fetchProfileData(): Promise<AxiosResponse> {
    return Axios.get("/api/account");
  }

  public fetchUserData(): Promise<AxiosResponse> {
    return Axios.get("/api/users/me");
  }

  public fetchSecuritySessions(): Promise<AxiosResponse> {
    return Axios.get("/api/security/sessions.json");
  }

  public fetchSecurityActivities(): Promise<AxiosResponse> {
    return Axios.get("/api/security/activities.json");
  }
}

const ProfileService = new ProfileServiceClass();

export default ProfileService;
